export const Errors = {
    NO_ACTIVE_PROMPTS: "NO_ACTIVE_PROMPTS",
    NO_ACTIVE_LLMS: "NO_ACTIVE_LLMS",
    UPGRADE_TO_PAID_PLAN: "UPGRADE_TO_PAID_PLAN",
    INSUFFICIENT_CREDITS: "INSUFFICIENT_CREDITS",
    ORGANIZATION_NOT_FOUND: "ORGANIZATION_NOT_FOUND",
  };
  